import { ExpansionTemplateInfo } from './Contexts';
import { useContext } from 'react';
import { xor } from './utils';

export default function TemplateNodeChannelSelector({
  nodeId,
  setChannelSelectorOpen,
  onEvent,

}){

  let expansionTemplateInfo = useContext(ExpansionTemplateInfo);


  let { template } = expansionTemplateInfo || {}
  let { channelGroups } = template;

  if( nodeId === "A"){
    console.log(channelGroups);
  }

  function onChannelToggle(checked,channelId){

    let newGroups = {...channelGroups};

    newGroups[nodeId] = xor(newGroups[nodeId]||[],channelId)

    onEvent({type:"dispatch",properties:{channelGroups:newGroups}});

  }


  return ( <div onClick={e => {
    e.stopPropagation();
  }} style={{
    position:'absolute',
    top:0,
    width:'calc(100% + 2px)',
    background:'white',
    border:'1px solid #ccc',
    transform:'translate(0,-100%)',
    padding:10,
    borderBottom:'none',
    background:'#f0f0f0',
  }}>
    <div>

      {Object.entries(template.compact.channels).map(([channelId,channelInfo]) => {
        
        let checked = channelGroups[ nodeId ]?.includes?.(channelId)
        console.log(channelId + " ? " + checked);

        return (
          <div onClick={e => {
            e.stopPropagation();
            onChannelToggle(!checked,channelId);
          }} class="sg-row v-center">
            <input style={{
              margin:5,
              fontSize:10,
              width:8,
            }} onChange={e => {

              e.preventDefault();
              onChannelToggle(e.target.checked,channelId);

            }} onClick={e => {
              e.stopPropagation();
            }} type="checkbox" 
              checked={checked}
              channelId={channelId}
              key={channelId+"-"+checked}

            />



            <div style={{fontSize:10}}>{channelInfo.label || ("Channel " + channelInfo.defaultValue)}</div>

          </div>
        )
      })}
    </div>

    {true && <div style={{marginTop:10}}>
      <button onClick={(e) => {
        e.stopPropagation()
        setChannelSelectorOpen(false);
      }}>Done</button>
    </div>}
  </div>)
}
